import React, { useEffect, useState } from "react";
import { useTerminalConfig } from "../../Path/NewTerminalConfigs";
import { FaTrash } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const RenderUploadBox = ({ handleLogoChange, logoImg, type }) => {
    const [logo, setLogo] = useState(logoImg);
    const [error, setError] = useState("");
    const { t } = useTranslation();
    const handleFileChange = (file) => {
        const maxSize = 10 * 1024 * 1024;

        if (!file) return;
        const allowedTypes =
            ["image/png", "image/jpeg"];
        if (!allowedTypes.includes(file.type)) {
            const msg = t("invalidFileType");
            setError(msg);
            return;
        }

        if (file.size > maxSize) {
            const msg = t("file_upload_limit");
            setError(msg);
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            handleLogoChange(type, reader.result);
            setLogo(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const clearFile = () => {
        setLogo(null);
        handleLogoChange(type, null); // ✅ clear only specific field

    };
    useEffect(() => {
        setLogo(logoImg)
    }, [logoImg])
    
      useEffect(() => {
      if (error) {
        const timer = setTimeout(() => {
          setError('');
        }, 2000);
    
        return () => clearTimeout(timer); // 🧼 Cleanup on unmount or re-run
      }
    }, [error]);

    return (
        <div className="bg-white rounded shadow-sm p-6 text-center">
            {!logo ? (
                <div
                    className="upload-area rounded p-6 flex flex-col items-center justify-center cursor-pointer border-2 border-dashed border-gray-300 hover:border-primary transition"
                    onClick={() => document.getElementById(`file`).click()}
                >
                    <p className="text-gray-700 font-medium mb-2">
                        {/* {t("image_drag")} */}
                    </p>
                    <button className="bg-blue-600 text-white px-4 py-2 rounded-md">
                        {t("chooseFile")}
                    </button>
                    <input
                        type="file"
                        id={`file`}
                        className="hidden"
                        accept={
                            "image/png,image/jpeg"
                        }
                        onChange={(e) => handleFileChange(e.target.files[0])}
                    />
                    <p className="text-gray-500 text-sm mt-3">
                        {t("file_upload_limit_terminal")}
                    </p>
                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                </div>
            ) : (
                <div className="">
                    <div className="relative bg-gray-50 rounded overflow-hidden flex flex-col items-center justify-center w-full h-40">
                        <FaTrash onClick={() => clearFile()} className="absolute top-0 right-0 m-2 text-red-500 hover:text-red-700 rounded" />
                        <img
                            src={logo}
                            alt={`preview`}
                            className={"object-contain w-32 h-32"}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

const LogoHeaderUploader = () => {
    const { terminalConfig, setTerminalConfig } = useTerminalConfig();
    const { t } = useTranslation();
    return (
        <div className="">
            <h1 className="text-2xl font-bold mb-8 text-left text-white">
                {t("upload_brand")}
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                    <h2 className="text-xl font-semibold text-white mb-4">{t("logo")}</h2>
                    <RenderUploadBox type="logo_url" logoImg={terminalConfig.logo_url}
                        handleLogoChange={(field, val) =>
                            setTerminalConfig((prev) => ({ ...prev, [field]: val }))
                        } />
                </div>
                <div>
                    <h2 className="text-xl font-semibold text-white mb-4">{t("header")}</h2>
                    <RenderUploadBox type="header_url" logoImg={terminalConfig.header_url}
                        handleLogoChange={(field, val) =>
                            setTerminalConfig((prev) => ({ ...prev, [field]: val }))}
                    />
                </div>
                <div>
                    <h2 className="text-xl font-semibold text-white mb-4">{t("background")}</h2>
                    <RenderUploadBox type='background_url' logoImg={terminalConfig.background_url}
                        handleLogoChange={(field, val) =>
                            setTerminalConfig((prev) => ({ ...prev, [field]: val }))}
                    />
                </div>
            </div>
        </div>
    );
}

export default LogoHeaderUploader;
